import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;

export function getAuthToken() {
    return localStorage.getItem("token");
}

export const apiClient = axios.create({
    baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


